import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Dropdown from 'flarum/common/components/Dropdown';
import Link from 'flarum/common/components/Link';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import humanTime from 'flarum/common/helpers/humanTime';
import classList from 'flarum/common/utils/classList';
import WarningPost from './WarningPost';
import WarningControls from './WarningControls';
export default class WarningListItem extends Component {
  view() {
    const {
      warning
    } = this.attrs;
    const addedByUser = warning.addedByUser();
    const controls = WarningControls.controls(warning, this).toArray();
    return m("div", this.elementAttrs(), controls.length ? Dropdown.component({
      icon: 'fas fa-ellipsis-v',
      className: 'WarningListItem-controls',
      buttonClassName: 'Button Button--icon Button--flat Slidable-underneath Slidable-underneath--right'
    }, controls) : '', m("div", {
      className: "WarningListItem-main"
    }, m("h3", {
      className: "WarningListItem-title"
    }, m(Link, {
      href: addedByUser ? app.route.user(addedByUser) : '#',
      className: "WarningListItem-author"
    }, m(Avatar, {
      user: addedByUser
    }), " ", username(addedByUser))), m("span", {
      class: "WarningListItem-strikes"
    }, warning.isHidden() ? app.translator.trans('fof-moderator-warnings.forum.warning_list_item.list_item_heading_hidden', {
      time: humanTime(warning.createdAt()),
      strikes: warning.strikes() || 0
    }) : app.translator.trans('fof-moderator-warnings.forum.warning_list_item.list_item_heading', {
      time: humanTime(warning.createdAt()),
      strikes: warning.strikes() || 0
    })), m("hr", null), m("ul", {
      className: "WarningListItem-info"
    }, warning.post() ? m("li", {
      className: "item-excerpt"
    }, m("h3", {
      className: "WarningListItem-subtitle"
    }, app.translator.trans('fof-moderator-warnings.forum.warning_list_item.linked_post')), WarningPost.component({
      post: warning.post()
    })) : '', m("li", {
      className: "item-excerpt"
    }, m("h3", {
      className: "WarningListItem-subtitle"
    }, app.translator.trans('fof-moderator-warnings.forum.warning_list_item.public_comment')), m("p", {
      class: "WarningListItem-comment"
    }, m.trust(warning.publicComment()))), app.session.user.canManageWarnings() && warning.privateComment() ? m("li", {
      className: "item-excerpt"
    }, m("h3", {
      className: "WarningListItem-subtitle"
    }, app.translator.trans('fof-moderator-warnings.forum.warning_list_item.private_comment')), m("p", {
      class: "WarningListItem-comment"
    }, m.trust(warning.privateComment()))) : '')));
  }
  elementAttrs() {
    const {
      warning
    } = this.attrs;
    const attrs = {};
    attrs.className = (attrs.className || '') + ' ' + classList({
      WarningListItem: true,
      'WarningListItem--hidden': warning.isHidden()
    });
    return attrs;
  }
}
flarum.reg.add('fof-moderator-warnings', 'forum/components/WarningListItem', WarningListItem);